import { Component, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { AccessGroupService } from './../access-group.service';
import { ChallengeSummaryService } from '../challenge-summary.service';
import { Store } from '@ngrx/store';
import { LambdaFunctionService } from '../../service/lambda-function.service';
import { CnAiService } from './challenges_service/cn-ai.service';
import { CnAiConfigComponent } from './cn-ai-config/cn-ai-config.component';
import { CnReportPopupComponent } from './cn-report-popup/cn-report-popup.component';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

declare var $: any;
declare var toastr: any;

@Component({
  selector: 'app-challenges',
  templateUrl: './challenges.component.html',
  styleUrls: ['./challenges.component.scss']
})

export class ChallengesComponent implements OnInit, OnDestroy {
  private destroy$ = new Subject<void>();
  @ViewChild(CnAiConfigComponent) aiConfigComponent: CnAiConfigComponent;
  @ViewChild(CnReportPopupComponent) reportPopupComponent: CnReportPopupComponent;

  modal: any;
  reset_confirm: string = '';
  public env: any;
  public main_menu: any;

  breakthrough_content: any = [];
  breakthrough_dropdown: any = [];
  edit_breakthrough: boolean = false;
  datadump_content: any = [];
  edit_datadump: boolean = false;
  question_content: any = [];
  question_dropdown: any = [];
  edit_question: boolean = false;
  breakthrough: any = [];
  data_dump: any = [0];
  question: any = [0];
  showBreakthrough: boolean = false;
  showDatadump: boolean = false;
  showQuestion: boolean = false;
  BtId: string = '';
  DdId: string = '';
  QtId: string = '';

  brainstorm: any = [0];
  brainstorm_content: any = [];
  prev_brainstorm_content: any = [];
  edit_brainstorm: boolean = true;
  checked_brainstorm: any = [];
  showBrainstorm: boolean = false;
  BsId: string = '';
  IpId: string;
  proposed_content: any = [];
  array_proposed_content: any = [];

  strengthen_content: any = '';
  doing_content: any = '';
  doing_dropdown: any = '';
  prev_doing_content: any = '';
  edit_strengthen: boolean = false;
  edit_doing: boolean = false;
  PtEvaluation_content: any = [];
  plus_content: any = [];
  plus: any = [0];
  thinking: any = [0];
  thinking_content: any = [];
  issue_content: any = [];
  issue_text: any = [];
  opp_content: any = [];
  opp_text: any = [];
  edit_plus: boolean = true;
  edit_opportunity: boolean = false;
  edit_issues: boolean = false;
  edit_thinking: boolean = false;
  edit_PtEvaluation: boolean = true;
  strengthen: any = [0];
  doing: any = [0];
  opportunities: any = [0];
  issues: any = [0];
  showPoint: boolean = false;
  showStrength: boolean = false;
  showDoing: boolean = false;
  StId: string = '';
  DoingId: string = '';
  PtId: string = '';
  selected_strength: string;
  selected_opp: any = [];
  selected_thinking: string;
  selected_issue: any = [];
  showPlus: boolean = false;
  showOpp: boolean = false;
  showIssue: boolean = false;
  showThink: boolean = false;
  count_plus: number = 0;
  count_opp: number = 0;
  count_issue: number = 0;
  count_think: number = 0;

  next_content: any = [];
  edit_next: boolean = false;
  short_content: any = [];
  mid_content: any = [];
  long_content: any = [];
  edit_plan: boolean = false;
  next24: any = [0];
  showPlan: boolean = false;
  showNext: boolean = false;
  NxtId: string = '';
  PlanId: string = '';
  args: any;
  email: string;

  constructor(
    public accessgroup: AccessGroupService,
    public router: Router,
    public allChallenge: ChallengeSummaryService,
    public store: Store<any>,
    public lmda_service: LambdaFunctionService,
    public aiService: CnAiService
  ) {}

  openAiConfig() {
    this.aiConfigComponent?.openModal();
  }

  openReportPopup() {
    this.reportPopupComponent?.openModal();
  }

  ngOnInit() {
    this.store.select<any>((state) => state.profile.accessGroupData).pipe(
      takeUntil(this.destroy$)
    ).subscribe((message) => {
      if (message) {
        this.main_menu = message['main_menu'];
        if (!message['main_menu']?.innovation_stations?.challenge && message.length > 0) {
          this.router.navigate(['/dashboard']);
        }
      }
    });
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  public allContentPDF() {
    $('.pdf-modal').css('display', 'flex');
    this.arguments('allContent');
  }

  public summaryPDF() {
    $('.pdf-modal').css('display', 'flex');
    this.arguments('summary');
  }

  public onActivate(event: any) {
    window.scroll(0, 0);
  }

  public resetConfirm() {
    $('.reset-modal').css('display', 'block');
  }

  public arguments(pdfName: string = '') {
    if (this.next_content == undefined) {
      this.next_content = '';
    }
    if (!this.thinking_content[0]) {
      this.thinking_content[0] = '';
    }

    this.args = {
      "format": "A4",
      "organization": "Organization",
      "content_type": "pdf",
      "breakthrough": this.breakthrough,
      "breakthrough_dropdown": this.breakthrough_dropdown,
      "breakthrough_content": this.breakthrough_content,
      "email": this.email,
      "cn_version": 'V. 2.04',
      "data_dump": this.data_dump,
      "datadump_content": this.datadump_content,
      "question": this.question,
      "question_dropdown": this.question_dropdown,
      "question_content": this.question_content,
      "brainstorm": this.brainstorm,
      "brainstorm_content": this.brainstorm_content,
      "proposed_content": this.proposed_content,
      "doing_dropdown": this.doing_dropdown,
      "doing_content": this.doing_content,
      "plus": this.plus,
      "plus_content": this.plus_content,
      "opp_content": this.opp_content,
      "opp_text": this.opp_text,
      "selected_opp": this.selected_opp,
      "issue_content": this.issue_content,
      "issue_text": this.issue_text,
      "selected_issue": this.selected_issue,
      "thinking_content": this.thinking_content,
      "selected_thinking": this.selected_thinking,
      "strengthen_content": this.strengthen_content,
      "short_content": this.short_content,
      "mid_content": this.mid_content,
      "long_content": this.long_content,
      "next24": this.next24,
      "next_content": this.next_content
    };

    this.createPDF(pdfName);
  }

  public createPDF(pdf_type: string = '') {
    if (pdf_type == 'summary') {
      this.args.template = "summary-pdf.html";
      this.args.filename = "";
      this.lmda_service.lambda_invoke('summary-pdf-dev-pdf', this.args, 'Summary');
    } else {
      this.args.template = "detailed.html";
      this.args.filename = "";
      this.lmda_service.lambda_invoke('detail-pdf-dev-pdf', this.args, 'Detailed');
    }
  }
}
